'use client';
import { FC } from 'react';
import cn from 'classnames';
import styles from '../navheader.module.scss';
import { RenderLogo } from './RenderLogo';
import { DesktopNavItems } from './DesktopNavItems';
import { NavDropdownContentProps, NavItem, PopoverMenuProps } from '../NavHeader.type';
import { responsiveBreakpointsPx } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';

interface NavLeftSectionProps {
    navLeftItems?: (NavItem | NavDropdownContentProps | PopoverMenuProps)[];
    logo?: string;
    logoUrl?: string;
    headerId?: string;
    isDarkTheme: boolean;
    handleSearchClose: () => void;
    navDropdownHoveredIndex: number | null;
    setHelpCenterHovered: (val: boolean) => void;
    setNavDropdownHoveredIndex: (val: number | null) => void;
    searchOpen: boolean;
    scheduleHoverClose: () => void;
    cancelHoverClose: () => void;
    popoverHoveredIndex: number | null;
    setPopoverHoveredIndex: (val: number | null) => void;
}

export const NavLeftSection: FC<NavLeftSectionProps> = ({
    navLeftItems,
    logo,
    logoUrl,
    headerId,
    isDarkTheme,
    handleSearchClose,
    navDropdownHoveredIndex,
    setHelpCenterHovered,
    setNavDropdownHoveredIndex,
    searchOpen,
    scheduleHoverClose,
    cancelHoverClose,
    popoverHoveredIndex,
    setPopoverHoveredIndex,
}) => {
    const viewportIsDesktopSized = useMediaQuery(`(min-width: ${responsiveBreakpointsPx['nav-tablet']}px)`);

    return (
        <div className={cn(styles.leftContent, { [styles.darktheme]: isDarkTheme })}>
            <RenderLogo logo={logo} logoUrl={logoUrl} headerId={headerId} styles={styles} />
            {viewportIsDesktopSized && (
                <ul className={styles.headingLinks}>
                    {navLeftItems?.map((item, index) => (
                        <DesktopNavItems
                            key={index}
                            handleSearchClose={handleSearchClose}
                            index={index}
                            isDarkTheme={isDarkTheme}
                            item={item}
                            navDropdownHoveredIndex={navDropdownHoveredIndex}
                            setHelpCenterHovered={setHelpCenterHovered}
                            setNavDropdownHoveredIndex={setNavDropdownHoveredIndex}
                            searchOpen={searchOpen}
                            scheduleHoverClose={scheduleHoverClose}
                            cancelHoverClose={cancelHoverClose}
                            popoverHoveredIndex={popoverHoveredIndex}
                            setPopoverHoveredIndex={setPopoverHoveredIndex}
                        />
                    ))}
                </ul>
            )}
        </div>
    );
};
